import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { parseTotal, parseObject, flattenProductTypes } from 'store/reducers/cart';
import { clearCart, trimCart, sendToQRcode, fetchPromos, patchPromo } from 'store/actions/index';
import CartModal from 'components/Cart/Modal/CartModal';
import { Layout, Button, message } from 'antd';

import styles from './CartFooter.module.css';

const { Footer } = Layout;

class CartFooter extends Component {
  state = { visible: false };

  toggleModal = () => {
    const toggle = !this.state.visible;
    this.setState(prev => ({ ...prev, visible: toggle }));
  };

  render() {
    const { totalCart } = this.props;
    return (
      <Fragment>
        <Footer className={styles.CartFooter}>
          <span className={styles.Span}>
            Selected: <strong>{totalCart}</strong> {totalCart === 1 ? 'product' : 'products'}
          </span>
          <Button onClick={this.toggleModal}>Preview Cart</Button>
          <Button onClick={this.props.clearCart} type="danger">
            Clear Cart
          </Button>
        </Footer>
        <CartModal
          clearCart={this.props.clearCart}
          trimCart={this.props.trimCart}
          sendToQRcode={this.props.sendToQRcode}
          visible={this.state.visible}
          toggleModal={this.toggleModal}
          data={this.props.cartData}
          fetchPromos={this.props.fetchPromos}
          handleSaveToPromo={this.handleSaveToPromo}
          promos={this.props.promos}
        />
      </Fragment>
    );
  }

  handleSaveToPromo = id => {
    const { patchPromo, cartData, clearCart } = this.props;
    const product_ids = cartData.map(obj => obj.id);

    patchPromo({ id, product_ids }).then(res => {
      console.log(res);
      this.toggleModal();
      clearCart();
      message.success('Products have been saved to promotion');
    });
  };
}

const mapStateToProps = state => {
  const { cart: cartById, promo } = state;
  const totalCart = parseTotal(cartById);
  const cartData = flattenProductTypes(parseObject(cartById));
  return {
    totalCart,
    cartData,
    promos: promo.promos,
  };
};

const mapDispatchToProps = { clearCart, trimCart, sendToQRcode, fetchPromos, patchPromo };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CartFooter);



// WEBPACK FOOTER //
// ./src/components/Cart/Footer/CartFooter.js